/**
 * News component
 *
 * Funktionen für News-Beiträge.
 */

import { onDomReady } from '../utils/dom';

/**
 * Durch einen Klick auf einen News-Beitrag wird automatisch der Link zur
 * Detailseite aufgerufen.
 */
function linkNewsBox() {
    document.querySelectorAll('.layout_list.linked-news-post').forEach((newsItem) => {
        newsItem.addEventListener('click', (e) => {
            // Wenn das geklickte Element ein Link ist, wird abgebrochen
            if (e.target instanceof HTMLElement && e.target.closest('a')) {
                return;
            }

            // Sonst wird der Link aufgerufen
            newsItem.querySelector('.more')?.click();
        });
    });
}

onDomReady(() => {
    linkNewsBox();
});
